// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__uq1HS","prevButton":"styles_prevButton__k1JYd","nextButton":"styles_nextButton__GXF2N"};